exports.init = function($) {
  const $nav_desktop = $("nav#nav-main-desktop");

  $nav_desktop.find("div#search-open").click(e => {
    const $button = $(e.currentTarget);
    const $search = $button.parent(".search");

    if ($(e.target).hasClass("search-icon") || $(e.target).parents().hasClass("search-icon")) {
      $search.toggleClass("open");
      e.stopPropagation();
    } else {
      if ($search.hasClass("open") && $search.find("input#search").val().trim() != "") {
        $search.find("form").submit();
      }
      $search.addClass("open");
    }

    const opened = $search.hasClass("open");

    if (opened) {
      setTimeout(() => $search.find("input#search").focus(), 10);
    }
    
    $button.siblings(".searchform").width(() => {
      const totalWidth = $search.parents("ul").width();
      return opened? totalWidth : 0;
    });
  });

  $nav_desktop.find("form#searchform input#search").keyup((e) => {
    $(e.currentTarget).siblings("label").css({opacity: $(e.currentTarget).val().length > 0 ? 0 : 1});
  });

  const $nav_mobile = $("nav#nav-main-mobile");

  $nav_mobile.find(".menu-mobile").click(e => {
    $(e.currentTarget).toggleClass("open").siblings().removeClass("open");

    $("body").toggleClass("fixed", $(e.currentTarget).hasClass("open"));
  })

  $nav_mobile.find(".search-mobile").click(e => {
    if (!$(e.target).closest('form').length) {
      const $elem = $(e.currentTarget);
      $elem.toggleClass("open").siblings().removeClass("open");
      if ($elem.hasClass("open")) {
        //$elem.find("input#search").focus();
      }

      $("body").toggleClass("fixed", $elem.hasClass("open"));
    }
  })
};
